import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS, FONTS } from '../../../constants'

export const styles = makeStyles(theme => ({
  modal: {
    outline: 'none',
    maxWidth: '100%',
    width: '100%',
    margin: '0 auto',
    color: theme.palette.common.black,
    ['& .ReactModal__Overlay']: {
      position: 'absolute',
    },
    [`@media (min-width: ${BREAKPOINTS.mdd}px)`]: {
      maxWidth: 600,
      ['& .MuiDialog-paper']: {
        maxWidth: 600,
        width: '100%',
      },
    },
  },
  modalContainer: {
    position: 'relative',
    outline: 'none',
    padding: '24px 20px 28px',
  },
  closeButton: {
    position: 'absolute',
    top: 18,
    right: 10,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    zIndex: 2,
    outline: 'none',
  },
  title: {
    margin: '8px 0 20px',
    paddingRight: 32,
  },
  fieldGroup: {
    marginBottom: 16,
    ['& input']: {
      width: '100%',
      border: `1px solid ${COLORS.ashGrey}`,
      borderRadius: 8,
      background: COLORS.white,
      padding: '12px 14px',
      fontSize: 14,
      height: 48,
      boxSizing: 'border-box',
      margin: 0,
      textAlign: 'left',
      letterSpacing: 0,
    },
  },
  fieldLabel: {
    display: 'block',
    marginBottom: 8,
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: 14,
    textTransform: 'lowercase',
  },
  sectionDivider: {
    margin: '8px 0 20px',
    borderTop: `1px solid ${COLORS.ashGrey}`,
  },
  sectionTitle: {
    marginBottom: 16,
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: 14,
    textTransform: 'lowercase',
  },
  description: {
    marginBottom: 20,
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: 14,
  },
  addLinkButton: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.common.black,
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: 14,
    textDecoration: 'underline',
    padding: 0,
    marginBottom: 24,
    outline: 'none',
  },
  fieldError: {
    color: COLORS.dangerRed,
    fontSize: 12,
    margin: '6px 0 0',
    fontFamily: FONTS.Graphik.GraphikLight,
  },
  formError: {
    color: COLORS.dangerRed,
    fontSize: 14,
    margin: '0 0 16px',
    fontFamily: FONTS.Graphik.GraphikLight,
  },
  actions: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    ['& button']: {
      flex: '1 1 140px',
      minWidth: 120,
    },
  },
  cancelButton: {
    background: COLORS.white,
    border: `2px solid ${theme.palette.common.black}`,
    ['& p']: {
      color: theme.palette.common.black,
    },
    ['&:hover']: {
      background: theme.palette.common.black,
      ['& p']: {
        color: theme.palette.common.white,
      },
    },
  },
  shortBioTextarea: {
    width: '100%',
    border: `1px solid ${COLORS.ashGrey}`,
    margin: 0,
    padding: '12px 14px',
    fontSize: '14px',
    background: COLORS.white,
    textAlign: 'left',
    borderRadius: 8,
    letterSpacing: '0',
    fontFamily: FONTS.Graphik.GraphikRegular,
    resize: 'none',
  },
  socialLinksContainer: {
    maxHeight: 'calc(3 * (48px + 24px))',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 6,
    marginRight: -6,
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    scrollbarColor: `${COLORS.ashGrey} transparent`,
    ['&::-webkit-scrollbar']: {
      width: 6,
    },
    ['&::-webkit-scrollbar-thumb']: {
      backgroundColor: COLORS.ashGrey,
      borderRadius: 3,
    },
  },
}))
